<template>
  <div class="relative flex h-full flex-col">
    <div
      class="flex w-full items-center justify-start space-x-6 border-b-2 border-b-ontick-graphite-500 bg-ontick-carbon-600 py-2 px-3"
    >
      <div v-if="Object.keys(strategies).length > 0" class="block w-[40%] lg:w-[30%]">
        <strategy-chart-header-component
          @listInvestment="listInvestment"
          :data="strategies"
        ></strategy-chart-header-component>
      </div>

      <div class="flex items-center justify-center space-x-1">
        <!-- <p class="text-xs font-medium text-ontick-steel-400 mr-1">Grade:</p> -->
        <!-- 1 gráfico -->
        <button class="rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md" @click="template = 1">
          <!-- Grid 1 -->
          <div class="flex flex-row space-x-0.5 rounded">
            <div
              :class="[
                template === 1 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                'h-[16px] w-[16px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 2 gráficos dividido horizontalmente na tela -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 2"
        >
          <!-- Grid 2 -->
          <div class="flex flex-row space-x-0.5 rounded">
            <div
              :class="[
                template === 2 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[16px] w-[8px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
            <div
              :class="[
                template === 2 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[16px] w-[8px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 2 gráficos dividido verticalmente na tela -->
        <button class="rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md" @click="template = 8">
          <!-- Grid 8 -->
          <div class="flex flex-col space-y-0.5 rounded">
            <div
              :class="[
                template === 8 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[7.25px] w-[16px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
            <div
              :class="[
                template === 8 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[7.25px] w-[16px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 3 gráficos - 1 esquerdo e 2 direito verticalmente -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 3"
        >
          <!-- Grid 3 -->
          <div class="flex flex-col space-y-0.5 rounded">
            <div
              :class="[
                template === 3 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[7.25px] w-full rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
            <div class="flex h-full flex-row space-x-0.5">
              <div
                :class="[
                  template === 3 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  ,
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 3 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  ,
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </button>
        <!-- 3 gráficos - 1 direito e 2 esquerdo verticalmente -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 4"
        >
          <!-- Grid 4 -->
          <div class="flex flex-col space-y-0.5 rounded">
            <div class="flex h-full flex-row space-x-0.5">
              <div
                :class="[
                  template === 4 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 4 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
            <div
              :class="[
                template === 4 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                'h-[7.25px] w-full rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 3 gráficos - 1 esquerdo e 2 direito -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 5"
        >
          <!-- Grid 5 -->
          <div class="flex flex-row space-x-0.5 rounded">
            <div
              :class="[
                template === 5 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[16px] w-[8px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
            <div class="flex h-full flex-col space-y-0.5">
              <div
                :class="[
                  template === 5 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 5 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </button>
        <!-- 3 gráficos - 2 esquerdo e 1 direito -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 6"
        >
          <!-- Grid 6 -->
          <div class="flex flex-row space-x-0.5 rounded">
            <div class="flex h-full flex-col space-y-0.5">
              <div
                :class="[
                  template === 6 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 6 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
            <div
              :class="[
                template === 6 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                'h-[16px] w-[8px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 4 gráficos -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 7"
        >
          <!-- Grid 7 -->
          <div class="flex flex-col space-y-0.5 rounded">
            <div class="flex h-full flex-row space-x-0.5">
              <div
                :class="[
                  template === 7 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 7 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
            <div class="flex h-full flex-row space-x-0.5">
              <div
                :class="[
                  template === 7 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 7 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </button>
      </div>

      <template v-if="selectedStrategy?.investment_id != 0">
        <button
          @click="updateAllMarkers()"
          content="Atualizar dados"
          v-tippy="{ arrow: true, theme: 'green' }"
          class="relative col-span-1 ml-2 hidden w-10 items-center py-2 text-ontick-blue-500 md:inline-flex md:px-2"
        >
          <span v-html="btnUpdateMarkers ? updateIcon.active : updateIcon.disabled"></span>
        </button>
      </template>

      <!-- Habilitar somente em "localhost" -->
      <!-- <button
        @click="debugDatafeedInLocalhost()"
        class="bg-[#7c3aed] px-3 py-1.5 rounded-md text-xs font-bold text-white"
      >
        Debug Datafeed
      </button> -->
    </div>

    <!--  -->
    <template v-if="template === 1">
      <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-y-2 divide-ontick-graphite-500">
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart01.toggleConfig"
            @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
            @click-outside="paramChart01.toggleConfig = false"
          >
            <ontick-editable-select-component
              inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
              maxHeight="max-h-96"
              :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
              :value="paramChart01.searchTicker"
              :acceptInput="true"
              name="symbol"
              @input="paramChart01.searchTicker = $event.value.toUpperCase()"
              @selected-from-box="changeSymbol($event, 'paramChart01')"
              @clear_field="clearField('paramChart01')"
              @close="paramChart01.searchTicker = paramChart01.ticker"
            />
            <portfolio-select-timeframe-component
              v-if="Object.keys(paramChart01).length > 0"
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              @change="changeTimeframe($event, 'paramChart01')"
            />
          </adjustment-chart-component>
          <portfolio-chart-grid-component
            :ticker="paramChart01.ticker"
            :timeframe="paramChart01.timeframe"
            :investmentId="paramChart01.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart01')"
            :selectedStrategy="selectedStrategy"
          />
        </div>
      </div>
    </template>

    <template v-if="template === 2">
      <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart01.toggleConfig"
            @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
            @click-outside="paramChart01.toggleConfig = false"
          >
            <ontick-editable-select-component
              inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
              maxHeight="max-h-96"
              :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
              :value="paramChart01.searchTicker"
              :acceptInput="true"
              name="symbol"
              @input="paramChart01.searchTicker = $event.value.toUpperCase()"
              @selected-from-box="changeSymbol($event, 'paramChart01')"
              @clear_field="clearField('paramChart01')"
              @close="paramChart01.searchTicker = paramChart01.ticker"
            />
            <portfolio-select-timeframe-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              @change="changeTimeframe($event, 'paramChart01')"
            />
          </adjustment-chart-component>

          <portfolio-chart-grid-component
            v-if="Object.keys(paramChart01).length > 0"
            :ticker="paramChart01.ticker"
            :timeframe="paramChart01.timeframe"
            :investmentId="paramChart01.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart01')"
            :selectedStrategy="selectedStrategy"
          />
        </div>
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart02.toggleConfig"
            @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
            @click-outside="paramChart02.toggleConfig = false"
          >
            <ontick-editable-select-component
              inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
              maxHeight="max-h-96"
              :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
              :value="paramChart02.searchTicker"
              :acceptInput="true"
              name="symbol"
              @input="paramChart02.searchTicker = $event.value.toUpperCase()"
              @selected-from-box="changeSymbol($event, 'paramChart02')"
              @clear_field="clearField('paramChart02')"
              @close="paramChart02.searchTicker = paramChart02.ticker"
            />
            <portfolio-select-timeframe-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              @change="changeTimeframe($event, 'paramChart02')"
            />
          </adjustment-chart-component>

          <portfolio-chart-grid-component
            v-if="Object.keys(paramChart02).length > 0"
            :ticker="paramChart02.ticker"
            :timeframe="paramChart02.timeframe"
            :investmentId="paramChart02.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart02')"
            :selectedStrategy="selectedStrategy"
          />
        </div>
      </div>
    </template>

    <template v-if="template === 8">
      <div v-if="hasParamChart" class="flex h-full flex-col divide-y-2 divide-ontick-graphite-500">
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart01.toggleConfig"
            @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
            @click-outside="paramChart01.toggleConfig = false"
          >
            <ontick-editable-select-component
              inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
              maxHeight="max-h-96"
              :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
              :value="paramChart01.searchTicker"
              :acceptInput="true"
              name="symbol"
              @input="paramChart01.searchTicker = $event.value.toUpperCase()"
              @selected-from-box="changeSymbol($event, 'paramChart01')"
              @clear_field="clearField('paramChart01')"
              @close="paramChart01.searchTicker = paramChart01.ticker"
            />
            <portfolio-select-timeframe-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              @change="changeTimeframe($event, 'paramChart01')"
            />
          </adjustment-chart-component>

          <portfolio-chart-grid-component
            v-if="Object.keys(paramChart01).length > 0"
            :ticker="paramChart01.ticker"
            :timeframe="paramChart01.timeframe"
            :investmentId="paramChart01.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart01')"
            :selectedStrategy="selectedStrategy"
          />
        </div>
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart02.toggleConfig"
            @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
            @click-outside="paramChart02.toggleConfig = false"
          >
            <ontick-editable-select-component
              inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
              maxHeight="max-h-96"
              :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
              :value="paramChart02.searchTicker"
              :acceptInput="true"
              name="symbol"
              @input="paramChart02.searchTicker = $event.value.toUpperCase()"
              @selected-from-box="changeSymbol($event, 'paramChart02')"
              @clear_field="clearField('paramChart02')"
              @close="paramChart02.searchTicker = paramChart02.ticker"
            />
            <portfolio-select-timeframe-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              @change="changeTimeframe($event, 'paramChart02')"
            />
          </adjustment-chart-component>

          <portfolio-chart-grid-component
            v-if="Object.keys(paramChart02).length > 0"
            :ticker="paramChart02.ticker"
            :timeframe="paramChart02.timeframe"
            :investmentId="paramChart02.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart02')"
            :selectedStrategy="selectedStrategy"
          />
        </div>
      </div>
    </template>

    <template v-if="template === 3">
      <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
        <div v-if="hasParamChart" class="flex h-full">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart01.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart01')"
                @clear_field="clearField('paramChart01')"
                @close="paramChart01.searchTicker = paramChart01.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart01.ticker"
                :timeframe="paramChart01.timeframe"
                @change="changeTimeframe($event, 'paramChart01')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
        <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart02.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart02')"
                @clear_field="clearField('paramChart02')"
                @close="paramChart02.searchTicker = paramChart02.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart02.ticker"
                :timeframe="paramChart02.timeframe"
                @change="changeTimeframe($event, 'paramChart02')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart03.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart03')"
                @clear_field="clearField('paramChart03')"
                @close="paramChart03.searchTicker = paramChart03.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart03.ticker"
                :timeframe="paramChart03.timeframe"
                @change="changeTimeframe($event, 'paramChart03')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="template === 4">
      <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
        <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart01.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart01')"
                @clear_field="clearField('paramChart01')"
                @close="paramChart01.searchTicker = paramChart01.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart01.ticker"
                :timeframe="paramChart01.timeframe"
                @change="changeTimeframe($event, 'paramChart01')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart02.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart02')"
                @clear_field="clearField('paramChart02')"
                @close="paramChart02.searchTicker = paramChart02.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart02.ticker"
                :timeframe="paramChart02.timeframe"
                @change="changeTimeframe($event, 'paramChart02')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
        <div v-if="hasParamChart" class="flex h-full">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart03.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart03')"
                @clear_field="clearField('paramChart03')"
                @close="paramChart03.searchTicker = paramChart03.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart03.ticker"
                :timeframe="paramChart03.timeframe"
                @change="changeTimeframe($event, 'paramChart03')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="template === 5">
      <div v-if="hasParamChart" class="flex h-full w-full flex-row divide-x-2 divide-ontick-graphite-500">
        <div class="flex w-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart01.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart01')"
                @clear_field="clearField('paramChart01')"
                @close="paramChart01.searchTicker = paramChart01.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart01.ticker"
                :timeframe="paramChart01.timeframe"
                @change="changeTimeframe($event, 'paramChart01')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
        <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart02.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart02')"
                @clear_field="clearField('paramChart02')"
                @close="paramChart02.searchTicker = paramChart02.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart02.ticker"
                :timeframe="paramChart02.timeframe"
                @change="changeTimeframe($event, 'paramChart02')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart03.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart03')"
                @clear_field="clearField('paramChart03')"
                @close="paramChart03.searchTicker = paramChart03.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart03.ticker"
                :timeframe="paramChart03.timeframe"
                @change="changeTimeframe($event, 'paramChart03')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="template === 6">
      <div v-if="hasParamChart" class="flex h-full w-full flex-row divide-x-2 divide-ontick-graphite-500">
        <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart01.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart01')"
                @clear_field="clearField('paramChart01')"
                @close="paramChart01.searchTicker = paramChart01.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart01.ticker"
                :timeframe="paramChart01.timeframe"
                @change="changeTimeframe($event, 'paramChart01')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart02.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart02')"
                @clear_field="clearField('paramChart02')"
                @close="paramChart02.searchTicker = paramChart02.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart02.ticker"
                :timeframe="paramChart02.timeframe"
                @change="changeTimeframe($event, 'paramChart02')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
        <div class="flex w-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart03.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart03')"
                @clear_field="clearField('paramChart03')"
                @close="paramChart03.searchTicker = paramChart03.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart03.ticker"
                :timeframe="paramChart03.timeframe"
                @change="changeTimeframe($event, 'paramChart03')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="template === 7">
      <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
        <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart01.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart01')"
                @clear_field="clearField('paramChart01')"
                @close="paramChart01.searchTicker = paramChart01.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart01.ticker"
                :timeframe="paramChart01.timeframe"
                @change="changeTimeframe($event, 'paramChart01')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart02.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart02')"
                @clear_field="clearField('paramChart02')"
                @close="paramChart02.searchTicker = paramChart02.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart02.ticker"
                :timeframe="paramChart02.timeframe"
                @change="changeTimeframe($event, 'paramChart02')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
        <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart03.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart03')"
                @clear_field="clearField('paramChart03')"
                @close="paramChart03.searchTicker = paramChart03.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart03.ticker"
                :timeframe="paramChart03.timeframe"
                @change="changeTimeframe($event, 'paramChart03')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart04.toggleConfig"
              @change="paramChart04.toggleConfig = !paramChart04.toggleConfig"
              @click-outside="paramChart04.toggleConfig = false"
            >
              <ontick-editable-select-component
                inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                maxHeight="max-h-96"
                :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                :value="paramChart04.searchTicker"
                :acceptInput="true"
                name="symbol"
                @input="paramChart04.searchTicker = $event.value.toUpperCase()"
                @selected-from-box="changeSymbol($event, 'paramChart04')"
                @clear_field="clearField('paramChart04')"
                @close="paramChart04.searchTicker = paramChart04.ticker"
              />
              <portfolio-select-timeframe-component
                :ticker="paramChart04.ticker"
                :timeframe="paramChart04.timeframe"
                @change="changeTimeframe($event, 'paramChart04')"
              />
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart04.ticker"
              :timeframe="paramChart04.timeframe"
              :investmentId="paramChart04.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart04')"
              :selectedStrategy="selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { mapGetters, mapActions } from "vuex";
import PortfolioStrategyChartHeaderComponent from "../components/portfolio-strategy-chart-header.component.vue";
import PortfolioSelectTimeframeComponent from "../components/portfolio-select-timeframe.component.vue";
import OntickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";
import StrategyChartHeaderComponent from "../components/strategy-chart-header.component.vue";
import PortfolioChartGridComponent from "../components/portfolio-chart-grid.component.vue";
import AdjustmentChartComponent from "../components/adjustment-chart.component.vue";
import EventBus from "../../../shared/utils/event_bus";

export default {
  name: "portfolio-chart",
  components: {
    PortfolioStrategyChartHeaderComponent,
    PortfolioSelectTimeframeComponent,
    OntickEditableSelectComponent,
    StrategyChartHeaderComponent,
    PortfolioChartGridComponent,
    AdjustmentChartComponent,
  },
  data() {
    return {
      inlineStyle: "color:orangered;font-size:14px;font-weight:bold;",

      availableSymbols: ["WINFUT", "WDOFUT", "CCMFUT", "BITFUT"],

      // Gráficos
      paramChart01: {},
      paramChart02: {},
      paramChart03: {},
      paramChart04: {},

      pageContext: uuidv4(),
      template: 1, //FIXME: temporariamente disponível apenas template 1, 3 e 8

      listContextUuid: [],
      // Estratégia selecionada
      selectedStrategy: {},

      // WebSocket
      connectionStatus: {
        awaitingConnection: false,
        retries: 0,
        error: false,
      },

      // Usado para correção do Streamer.
      positions: [],

      // Botão de atualizar Markers
      btnUpdateMarkers: false,
      updateIcon: {
        active: `<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
        disabled: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
      },
    };
  },
  computed: {
    ...mapGetters({
      getWebsocketIsConnected: "config/getWebsocketIsConnected",
      selectedAccount: "accountTypes/getSelectedAccount",
      strategies: "performance/getStrategies",
    }),
    hasParamChart() {
      if (this.template === 1) {
        return Object.keys(this.paramChart01).length > 0;
      }
      if (this.template === 2 || this.template === 8) {
        return Object.keys(this.paramChart01).length > 0 && Object.keys(this.paramChart02).length > 0;
      }
      if ([3, 4, 5, 6].includes(this.template)) {
        return (
          Object.keys(this.paramChart01).length > 0 &&
          Object.keys(this.paramChart02).length > 0 &&
          Object.keys(this.paramChart03).length > 0
        );
      }
      if (this.template === 7) {
        return (
          Object.keys(this.paramChart01).length > 0 &&
          Object.keys(this.paramChart02).length > 0 &&
          Object.keys(this.paramChart03).length > 0 &&
          Object.keys(this.paramChart04).length > 0
        );
      }
      return false;
    },
    hasStrategyInAccount() {
      if (Object.keys(this.strategies).length > 0 && this.strategies.accounts.length > 0) {
        const strategyId = Number.parseInt(this.$route.query.strategyId || 0, 10);
        const hasStrategy = this.strategies.accounts[0].investments.some(
          (inv) => Number.parseInt(inv.investment_id, 10) === strategyId
        );
        return hasStrategy;
      }
      return false;
    },
    topics() {
      let topics = [];
      this.positions.forEach((pos) => {
        if (["PORTFOLIO", "MULTISYMBOL"].includes(pos.type)) {
          pos.curr_positions.forEach((curr) => {
            topics.push(curr.position_symbol);
          });
        } else {
          topics.push(pos.position_symbol);
        }
      });
      return Array(...new Set(topics)).map((symbol) => `MD.${symbol}.L1`);
    },
  },
  watch: {
    template: {
      deep: true,
      handler(value) {
        this.resetGridParams();
        setTimeout(() => this.setGridParams(this.selectedStrategy), 500);
        return value;
      },
    },
    selectedAccount: {
      deep: true,
      async handler(value) {
        await this.fetchAccounts(value);
        if (this.selectedAccount.account_id) {
          this.getRealTime(this.selectedAccount.account_id)
            .then(({ orders, positions }) => {
              // this.orders = orders;
              this.positions = positions;
            })
            .catch((err) => {
              console.error(err);
            });
        }
        return value;
      },
    },
  },

  created() {
    const scriptURL = "tradingview/charting_library/charting_library.standalone.js"; // Substitua pelo caminho correto
    if (!this.isScriptLoaded(scriptURL)) {
      this.addScript(scriptURL, () => {});
    }
  },

  // Checa se a aba está visível ao usuário,
  // Nesse caso, quando a aba estiver invisível podemos parar o websocket.
  /*
  created() {
    // https://developer.mozilla.org/pt-BR/docs/Web/API/Page_Visibility_API
    // A API de visibilidade de página deixa você saber quando uma página da web
    // está visível ou em foco. Por exemplo, se a sua aplicação web estiver
    // reproduzindo um video, ela pode pausar durante o momento que o usuário estiver
    // olhando para outra aba, e reproduz novamente quando o usuário retorna para a aba.
    function handleVisibilityChange() {
      console.log("[handleVisibilityChange] hidden", document.hidden);
      console.log("[handleVisibilityChange] visible", document.visible);
      if (document.hidden) {
        console.log("%c% PAUSE %", "font-size:64px;font-weight:bold;background:#c026d3;padding:4px;");
      } else {
        console.log("%c% START %", "font-size:64px;font-weight:bold;background:#059669;padding:4px;");
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange, false);
  },
  */
  async mounted() {
    if (Object.keys(this.selectedAccount).length > 0) {
      await this.fetchAccounts(this.selectedAccount);
      if (this.selectedAccount.account_id) {
        this.getRealTime(this.selectedAccount.account_id)
          .then(({ orders, positions }) => {
            this.orders = orders;
            this.positions = positions;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }

    // Parar com efeito de loading do botão btnUpdateMarkers.
    EventBus.$on("STOP_BTN_UPDATE_MARKERS", () => (this.btnUpdateMarkers = false));

    EventBus.$on("RESTART_CONSUMER", (isEmpty) => {
      // this.logEvent("[STRATEGY] RESTART_CONSUMER - mounted");
      this.consume(isEmpty);
      // this.updateAllMarkers();
    });
    EventBus.$on("MARKET_DATA", ({ symbol, data }) => {
      if (data.timeframe != "L1") {
        EventBus.$emit("REALTIME_TO_PORTFOLIO_CHART_GRID", { symbol, data });
      }
    });
  },
  destroyed() {
    this.worker.sendMessage({ type: "STOP_CONSUMING", data: this.pageContext });
  },
  methods: {
    ...mapActions({
      fetchAccounts: "performance/fetchAccounts",
    }),
    isScriptLoaded(scriptSrc) {
      const scripts = document.head.getElementsByTagName("script");
      return Array.from(scripts).some((item) => item.src.includes(scriptSrc));
    },
    addScript(url, callback) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;

      script.onload = function () {
        if (callback) {
          callback();
        }
      };

      script.onerror = function () {
        console.error("Erro ao carregar o script: " + url);
      };

      document.head.appendChild(script);
    },
    listInvestment(strategy) {
      // this.logTitle("listInvestment");
      if (Number(strategy.investment_id) != 0) {
        if (Number(strategy.investment_id) != Number(this.$route.query.strategyId)) {
          this.$router.replace({ name: "StrategyChart", query: { strategyId: strategy.investment_id } });
        }
        this.selectedStrategy = strategy;
        this.setGridParams(strategy);
        // this.consume();
      } else {
        EventBus.$emit("CLEAR_MARKERS");
        if (Object.keys(this.selectedStrategy).length > 0) {
          this.setGridParams(this.selectedStrategy, true);
          this.selectedStrategy.investment_id = 0;
        } else {
          const newItemDefault = {
            investment_id: 0,
            investment_symbol: "WINFUT",
            investment_timeframe: "M10",
          };
          this.selectedStrategy = newItemDefault;
          this.setGridParams(newItemDefault);
        }
        if (this.$router?.query?.strategyId) {
          this.$router.replace({ name: "StrategyChart" });
        }
      }
    },
    resetGridParams() {
      this.paramChart01 = {};
      this.paramChart02 = {};
      this.paramChart03 = {};
      this.paramChart04 = {};
    },
    setGridParams(selectedStrategy, isCleanChart = false) {
      let itemSelected = {
        investmentId: isCleanChart ? 0 : Number(selectedStrategy.investment_id),
        // ticker: selectedStrategy.investment_symbol,
        // searchTicker: selectedStrategy.investment_symbol,
        // timeframe: selectedStrategy.investment_timeframe,
        // timeframe: "M10", //FIXME: remover timeframe mockado temporariamente
        toggleConfig: false,
      };

      const availableTimeframe = ["S15", "S30", "M1", "M2", "M3", "M5", "M6", "M10", "M12", "M15", "M30", "H1"];
      if (!isCleanChart) {
        itemSelected.ticker = selectedStrategy.investment_symbol;
        itemSelected.searchTicker = selectedStrategy.investment_symbol;
        itemSelected.timeframe = availableTimeframe.includes(selectedStrategy.investment_timeframe)
          ? selectedStrategy.investment_timeframe
          : "M15";
      }

      if (this.template === 1) {
        this.paramChart01 = { ...this.paramChart01, ...itemSelected };
        this.paramChart02 = {};
        this.paramChart03 = {};
        this.paramChart04 = {};
      }

      if (this.template === 2 || this.template === 8) {
        this.paramChart01 = { ...this.paramChart01, ...itemSelected };
        this.paramChart02 = { ...this.paramChart02, ...itemSelected };
        this.paramChart03 = {};
        this.paramChart04 = {};
      }

      if ([3, 4, 5, 6].includes(this.template)) {
        this.paramChart01 = { ...this.paramChart01, ...itemSelected };
        this.paramChart02 = { ...this.paramChart02, ...itemSelected };
        this.paramChart03 = { ...this.paramChart03, ...itemSelected };
        this.paramChart04 = {};
      }

      if (this.template === 7) {
        this.paramChart01 = { ...this.paramChart01, ...itemSelected };
        this.paramChart02 = { ...this.paramChart02, ...itemSelected };
        this.paramChart03 = { ...this.paramChart03, ...itemSelected };
        this.paramChart04 = { ...this.paramChart04, ...itemSelected };
      }
    },
    changeTimeframe(timeframe, paramChart) {
      if (paramChart === "paramChart01") {
        this.paramChart01.timeframe = timeframe;
      }
      if (paramChart === "paramChart02") {
        this.paramChart02.timeframe = timeframe;
      }
      if (paramChart === "paramChart03") {
        this.paramChart03.timeframe = timeframe;
      }
      if (paramChart === "paramChart04") {
        this.paramChart04.timeframe = timeframe;
      }
    },
    changeSymbol(symbol, paramChart) {
      if (paramChart === "paramChart01") {
        this.paramChart01.ticker = symbol;
        this.paramChart01.searchTicker = symbol;
        // Para CCMFUT e BITFUT, só tem timeframe M1 e M15.
        if (["CCMFUT", "BITFUT"].includes(symbol)) {
          if (!["M1", "M15"].includes(this.paramChart01.timeframe)) {
            this.paramChart01.timeframe = "M15";
          }
        }
      }
      if (paramChart === "paramChart02") {
        this.paramChart02.ticker = symbol;
        this.paramChart02.searchTicker = symbol;
        // Para CCMFUT e BITFUT, só tem timeframe M1 e M15.
        if (["CCMFUT", "BITFUT"].includes(symbol)) {
          if (!["M1", "M15"].includes(this.paramChart02.timeframe)) {
            this.paramChart02.timeframe = "M15";
          }
        }
      }
      if (paramChart === "paramChart03") {
        this.paramChart03.ticker = symbol;
        this.paramChart03.searchTicker = symbol;
        // Para CCMFUT e BITFUT, só tem timeframe M1 e M15.
        if (["CCMFUT", "BITFUT"].includes(symbol)) {
          if (!["M1", "M15"].includes(this.paramChart03.timeframe)) {
            this.paramChart03.timeframe = "M15";
          }
        }
      }
      if (paramChart === "paramChart04") {
        this.paramChart04.ticker = symbol;
        this.paramChart04.searchTicker = symbol;
        // Para CCMFUT e BITFUT, só tem timeframe M1 e M15.
        if (["CCMFUT", "BITFUT"].includes(symbol)) {
          if (!["M1", "M15"].includes(this.paramChart04.timeframe)) {
            this.paramChart04.timeframe = "M15";
          }
        }
      }
    },
    clearField(paramChart) {
      if (paramChart === "paramChart01") {
        this.paramChart01.searchTicker = "";
      }
      if (paramChart === "paramChart02") {
        this.paramChart02.searchTicker = "";
      }
      if (paramChart === "paramChart03") {
        this.paramChart03.searchTicker = "";
      }
      if (paramChart === "paramChart04") {
        this.paramChart04.searchTicker = "";
      }
    },
    consume(isEmpty = false) {
      // Parar de consumir no contexto "pageContext".
      this.worker.sendMessage({ type: "STOP_CONSUMING", data: this.pageContext });

      if (this.connectionStatus.retries > 5) {
        this.connectionStatus.error = true;
        this.connectionStatus.awaitingConnection = false;
        console.error("[ADMIN] Erro ao conectar ao websocket.");
        return;
      }
      if (!this.getWebsocketIsConnected) {
        if (this.isSharedWorker) {
          this.worker.sendMessage({ type: "CHECK_CONNECTION" });
        }
        this.connectionStatus.retries++;
        this.connectionStatus.awaitingConnection = true;
        setTimeout(() => {
          // this.logTitle("Lógica de retry");
          this.consume();
        }, 2000);
        return;
      }
      this.connectionStatus.awaitingConnection = false;
      this.connectionStatus.error = false;

      let arrayTopicsMD = [];
      this.listContextUuid.forEach(({ ctx, paramChart }) => {
        let _symbol, _tf;

        if (paramChart === "paramChart01") {
          _symbol = this.paramChart01.ticker;
          _tf = this.paramChart01.timeframe;
        } else if (paramChart === "paramChart02") {
          _symbol = this.paramChart02.ticker;
          _tf = this.paramChart02.timeframe;
        } else if (paramChart === "paramChart03") {
          _symbol = this.paramChart03.ticker;
          _tf = this.paramChart03.timeframe;
        } else if (paramChart === "paramChart04") {
          _symbol = this.paramChart04.ticker;
          _tf = this.paramChart04.timeframe;
        }

        arrayTopicsMD.push(`MD.${_symbol}.${_tf}`);
      });
      this.worker.sendMessage({
        type: "CONSUME",
        data: {
          uuid: this.pageContext,
          // topics: !isEmpty ? [...this.topics, ...arrayTopicsMD] : [...this.topics],
          topics: this.removeDuplicateValues([...this.topics, ...arrayTopicsMD]),
          type: "Admin",
        },
      });
      this.worker.sendMessage({ type: "LOG" });
    },
    removeDuplicateValues(arrayTopics) {
      return arrayTopics.filter((item, pos, self) => self.indexOf(item) == pos);
    },
    setContextUuid(ctx, paramChart) {
      this.listContextUuid.push({
        ctx,
        paramChart,
      });
    },
    getRealTime(account) {
      return new Promise((resolve, reject) => {
        this.$api
          .get(`${this.$endpoint.REAL_TIME}/${account}`)
          .then((res) => {
            resolve({
              orders: res.data.orders,
              positions: res.data.positions,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateAllMarkers() {
      this.btnUpdateMarkers = true;
      EventBus.$emit("RESTART_MARKERS");
    },
    isLocalhost() {
      return Boolean(
        window.location.hostname === "localhost" ||
          // [::1] is the IPv6 localhost address.
          window.location.hostname === "[::1]" ||
          // 127.0.0.1/8 is considered localhost for IPv4.
          window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
      );
    },
    logTitle(message = "", color = "red") {
      if (this.isLocalhost()) {
        const inlineStyle = `font-size:28px;font-weight:bold;padding:5px 10px;color:white;background-color:${color}`;
        console.log("%c%s", inlineStyle, message);
      }
    },
    logEvent(msg) {
      if (this.isLocalhost()) {
        console.log(
          "%c[RECEIVED]<<<%s>>>",
          "font-size:18px;font-weight:bold;color:yellow;border:2px solid red;padding:8px;",
          msg
        );
      }
    },
    // Habilitar somente em "localhost"
    /*
    debugDatafeedInLocalhost() {
      EventBus.$emit("SHOW_CHANNEL_SUBSCRIPTION");
    },
    */
  },
};
</script>
